// Hook for query source navigation
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { QueryEntity } from "../../domain/entities/QueryEntity";
import {
  navigateToQuerySource,
  hasNavigableSource,
  NavigationOptions,
} from "../utils/navigationHelpers";

/**
 * Hook for navigating to query source documents
 *
 * @example
 * const { navigateToSource, canNavigate } = useQueryNavigation();
 *
 * if (canNavigate(query)) {
 *   navigateToSource(query);
 * }
 */
export const useQueryNavigation = () => {
  const navigate = useNavigate();

  const navigateToSource = useCallback(
    (query: QueryEntity, options?: NavigationOptions) => {
      navigateToQuerySource(query, navigate, options);
    },
    [navigate]
  );

  const canNavigate = useCallback((query: QueryEntity): boolean => {
    return hasNavigableSource(query);
  }, []);

  return {
    navigateToSource,
    canNavigate,
  };
};
